if (!window.GUI) {
    window.GUI = {};
}

// FF 4.0       mozilla/5.0 (windows nt 6.1; rv:2.0.1) gecko/20100101 firefox/4.0.1
// Chrome 11    mozilla/5.0 (windows nt 6.1) applewebkit/534.24 (khtml, like gecko) chrome/11.0.696.71 safari/534.24
// Opera 11     opera/9.80 (windows nt 6.1; u; ru) presto/2.6.30 version/10.63
// Safari 5     mozilla/5.0 (windows; u; windows nt 6.1; en-us) applewebkit/533.18.1 (khtml, like gecko) version/5.0.2 safari/533.18.5
// IE -         mozilla/4.0 (compatible; msie 7.0; windows nt 6.1; trident/4.0; gtb6.6; slcc2; .net clr 2.0.50727; .net clr 3.5.30729; .net clr 3.0.30729; media center pc 6.0; .net4.0c; .net4.0e)
//              mozilla/4.0 (compatible; msie 8.0; windows nt 6.1; trident/4.0; gtb6.6; slcc2; .net clr 2.0.50727; .net clr 3.5.30729; .net clr 3.0.30729; media center pc 6.0; .net4.0c; .net4.0e)
//              mozilla/5.0 (compatible; msie 9.0; windows nt 6.1; wow64; trident/5.0)

(function () {
   // Gets data of userAgent
    var ua =  navigator.userAgent.toLowerCase();
// Sets opera, ie, ie8, ie9
    var opera = !!window.opera,
        ie    = !!(window.attachEvent && !window.opera) || ua.indexOf('trident') > 1,
        edge  = ua.indexOf('edge') > -1,
        ie6, ie7, ie8, ie9, ie10, ie11;

    if (ie) {
        if (ua.indexOf("msie 10") > -1) {
            ie10 = true;
        } else if (ua.indexOf("msie 9") > -1) {
            ie9 = true;
        } else if (ua.indexOf("msie 8") > -1) {
            ie8 = true;
        } else if (ua.indexOf("msie 7") > -1) {
            ie7 = true;
        } else if (ua.indexOf("msie 6") > -1) {
            ie6 = true;
        } else if (ua.indexOf('rv:11') > -1) {
            ie11 = true
        }
    }

    // Sets chrome, firefox, firefox4, safari, safari5, gecko, gecko2
    var chrome  = (/chrome/).test(ua),

        firefox = (/firefox/).test(ua),
        firefox4 = ua.indexOf('firefox/4') > -1,

        safari	= !chrome && (/webkit|khtml/).test(ua),
        safari5	= safari && ua.indexOf('webkit/5') > -1,

        gecko	= !chrome && !safari && ua.indexOf('gecko') > -1 && ua.indexOf('trident') === -1,
        gecko2  = gecko && ua.indexOf('rv:2.0') > -1,

        webkit5 = ua.indexOf('webkit/5') > -1;

    // Gets data of the platform
    var platform = navigator.platform.toLowerCase();

    // Sets win, mac, unix
    var win = (/win/).test(platform),
        mac = (/mac/).test(platform),
        unix = (/unix/).test(platform);

    // Add tags after loading the document
    function addTags() {
        var css_classes = '';

        if (win) {css_classes += 'win '; }
        if (mac) {css_classes += 'mac '; }
        if (unix) {css_classes += 'unix '; }

        if (opera) {css_classes += 'opera '; }

        if (ie) {css_classes += 'ie '; }
        if (ie7) {css_classes += 'ie7 '; }
        if (ie8) {css_classes += 'ie8 '; }
        if (ie9) {css_classes += 'ie9 '; }
        if (ie10) {css_classes += 'ie10 '; }
        if (ie11) {css_classes += 'ie11 '; }

        if (edge) {css_classes += 'edge ';}

        if (chrome) {css_classes += 'chrome '; }

        if (firefox) {css_classes += 'firefox '; }
        if (firefox4) {css_classes += 'firefox4 '; }

        if (safari) {css_classes += 'safari '; }
        if (safari5) {css_classes += 'safari5 '; }

        if (webkit5) {css_classes += 'webkit5 '; }

        if (gecko) {css_classes += 'gecko '; }
        if (gecko2) {css_classes += 'gecko2 '; }

        var bd = document.body || document.documentElement;
        if (bd && bd.parentNode) {
            bd.parentNode.className = css_classes;
        }
    }

    window.onload = addTags;

    // Core private variables
    var isMobileSafari, isStrict, isBorderBox,
        ElementExtensions, libPath, debug, themesPath,

        blockSelectionHandler,
        StringBuffer,

        currentId       = 0,
        preloadedImages = {},
        undoCache       = {},
        _rgbRe          = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i,
        _hexRe          = /^\#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/,
        _alphaRe        = /alpha\([^\)]*\)/gi;

    isMobileSafari  = !!ua.match(/apple.*mobile.*safari/);
    isStrict        = document.compatMode === "CSS1Compat";
    isBorderBox     =  ie && !isStrict;

    ElementExtensions = !!window.HTMLElement;
    libPath         = window.libPath || '';
    themesPath      = window.themesPath || '';
    debug           = !!window.debug;

    if (!window.JSGUI_THEME) {
        window.JSGUI_THEME = 'default';
    }

    if (!window.JSGUI_IMAGES_PATH) {
        window.JSGUI_IMAGES_PATH = libPath + 'img/' + window.JSGUI_THEME + '/';
    }

    if (window.autoDestroy === undefined) {
        window.autoDestroy = true;
    }

    /**
     * Convert string to num
     * @param {String} str
     * @returns {Number}
     */
    function getDim(str) {
        str = String(str);
        if (str === '') {
            return 0;
        } else {
            var res = parseInt(str, 10);
            if (isNaN(res)) {
                // alert(typeof str + ',' + str + arguments.callee.caller.toString());
            }
            return res;
        }
    }

    if (window.language && window.languagesRtl) {
        GUI.LTR = window.languagesRtl.split(',').indexOf(window.language) === -1;
    } else {
        GUI.LTR = true;
    }

    /**
     * Stops event
     * @param {Event} e Event
     */
    blockSelectionHandler = function (e) {GUI.preventDefault(e); GUI.stopEvent(e); };

    /**
     * Checking, is mobile browser (phone or table)
     */
    function isMobileBrowser() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    function isSmallBrowser()
    {
        return (window.innerHeight <= 600 || window.innerWidth <= 1024);
    }

    /**
     * JavaScript Graphical User Interface
     * Core script
     *
     * @author Eugene Lyulka
     * @author S. [LinuZz] Ostapenko
     * @version 2.0
     */
    Object.extend(GUI, {
        emptyImageUrl   : window.JSGUI_IMAGES_PATH + 's.gif',
        emptyFunction   : function () {},
        preloadedImages : preloadedImages,
        debug           : debug,

        // All constants are defined here
        Constants       : {
            libPath : libPath
        },

        // Browser detection
        isOpera         : opera,
        isIE            : ie,
        isNewIE         : ua.indexOf('Trident'),
        isIE6           : ie6,
        isIE7           : ie7,
        isIE8           : ie8,
        isIE9           : ie9,
        isIE10          : ie10,
        isIE11          : ie11,
        isEdge          : edge,
        isChrome        : chrome,
        isSafari        : safari,
        safari5         : safari5,
        isWebkit        : safari,
        isGecko         : gecko,
        isGecko2        : gecko2,
        firefox         : firefox,
        firefox4        : firefox4,
        isMobile        : isMobileBrowser(),
        isSmallMobile   : isMobileBrowser() && isSmallBrowser(),

        isMobileSafari  : isMobileSafari,
        isStrict        : isStrict,
        isBorderBox     : isBorderBox,
        ElementExtensions: ElementExtensions,
        SpecificElementExtensions:
            document.createElement('div')['__proto__'] &&
            document.createElement('div')['__proto__'] !==
            document.createElement('form')['__proto__'],

        /**
         *
         */
        getBody : function () {
            return GUI.Dom.extend(document.body || document.documentElement);
        },

        /**
         * Returns unique ID
         *
         * @param {String} prefix
         * @return {String}
         */
        getUniqId : function (prefix) {
            currentId++;
            if (!GUI.isSet(prefix)) {
                prefix = '';
            }
            return prefix + currentId;
        },

        /**
         * Returns a Universally Unique IDentifier (UUID)
         * RFC 4122 v4 compatible
         * http://stackoverflow.com/a/2117523
         *
         * @author broofa
         * @returns {String}
         */
        getUUID : function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (c) {
                    var r = Math.random() * 16 | 0,
                        v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                }
            );
        },

        /**
         * Sets handler to call when dom tree is ready
         * @param {Function} handler
         */
        onDOMReady: function (handler) {
            if (!GUI.isGecko || !GUI.isGecko2) {
                document.on('dom:loaded', handler);
            } else {
                document.on('readystatechange', handler);
            }
        },

        /**
         * empty function
         */
        preloadImage: function () {
            return; // Disabled... Very slow
        },

        /**
         *
         */
        preloadCssImages: function () {
            var i, j, len, src,
                rulesLen, csshref, baseURLarr, baseURL, imgUrls,
                thisSheetRules,
                sheets = document.styleSheets,
                shLen = sheets.length,  // array of stylesheets
                cssPile = new GUI.StringBuffer(); // create large string of all css rules in sheet

            for (i = 0; i < shLen; i++) {
                // loop through each stylesheet
                csshref = (sheets[i].href) || window.location.href;
                baseURLarr = csshref.split('/'); // split href at / to make array

                baseURLarr.pop(); // remove file path from baseURL array
                baseURL = baseURLarr.join('/'); // create base url for the images in this sheet (css file's dir)

                if (baseURL !== "") {
                    baseURL += '/'; //tack on a / if needed
                }
                cssPile.clear();

                if (sheets[i].cssRules) {
                    thisSheetRules = sheets[i].cssRules;
                    for (j = 0, rulesLen = thisSheetRules.length; j < rulesLen; j++) {
                        cssPile.append(thisSheetRules[j].cssText);
                    }
                } else {
                    cssPile.append(sheets[i].cssText);
                }

                // parse cssPile for image urls and load them into the DOM
                imgUrls = cssPile.toString().match(/[^\(]+\.(gif|jpg|jpeg|png)/g); // reg ex to get a string of between a "(" and a ".filename"
                if (imgUrls !== null && imgUrls.length > 0 && imgUrls !== '') {
                    // loop array
                    for (j = 0, len = imgUrls.length; j < len; j++) {
                        src = imgUrls[j];
                        src = (src[0] === '/' || src.match('http://'))
                            ? src : baseURL + src;
                        GUI.preloadImage(src);
                    }
                }
            } // loop
        },

        /**
         * Loads theme's css files if needed and applies the specified theme
         * @param {String} theme New theme
         * @param {String} cssPath Url of the folder with css
         */
        setTheme: function (theme, cssPath) {
            var sheets, i, themeLoaded, head, sh, prevCssPath,
                cssFiles, cssBefore, cssAfter,
                prevTheme = window.JSGUI_THEME;
            if (theme === prevTheme) {
                return;
            }
            // Check if theme's stylesheets are loaded and enabled
            sheets = document.styleSheets;
            i = sheets.length;
            themeLoaded = false;

            if (!cssPath) {
                cssPath  = window.libPath + 'css/' + theme + '/';
            }

            while (i--) {
                sh = sheets[i];
                if (sh.disabled && (sh.href.indexOf(cssPath) > -1)) {
                    themeLoaded = true;
                    sh.disabled = false;
                }
            }

            if (!themeLoaded) {
                // Need to load theme's css files
                cssFiles = window.debug ? [
                    'x-loader.css',
                    'x-layout.css',
                    'x-region.css',
                    'x-hint.css',
                    'x-mask.css',
                    'x-dialog.css',
                    'x-messages.css',
                    'x-inlineedit.css',
                    'x-menu.css',
                    'x-tree.css',
                    'x-grid.css',
                    'x-toolbar.css',
                    'x-tabbar.css',
                    'x-paging.css',
                    'global.gridfilterslayout.css',
                    'x-actions.css',
                    'x-calendar.css',
                    'x-colorpanel.css',
                    'x-forms.css',
                    'x-quickbar.css',
                    'x-main-container.css',
                    'x-wizard.css',
                    'x-informer.css',
                    'x-autocompleter.css',
                    'x-progressbar.css',
                    'x-popupinformer.css',
                    'x-container.css'
                ] : [
                    'jsgui-all.css'
                ];

                cssBefore = '<link href="' + libPath + cssPath;
                cssAfter = '" rel="stylesheet" type="text/css" />';

                cssFiles = cssBefore + cssFiles.join(cssAfter + cssBefore) + cssAfter;

                head = document.getElementsByTagName('head')[0];
                GUI.Dom.append(head, cssFiles);
            }

            if (prevTheme !== 'default') {
                // Disable last used custom theme css
                prevCssPath = window.libPath + 'css/' + prevTheme + '/';
                i = sheets.length;
                while (i--) {
                    sh = sheets[i];
                    if (!sh.disabled && (sh.href.indexOf(prevCssPath) > -1)) {
                        sh.disabled = false;
                    }
                }
            }
            window.JSGUI_THEME = theme;
        },

        /**
         * Append to the element div with class name 'clear'
         */
        appendClearDiv: function (to) {
            var div = document.createElement('div');
            div.className = 'clear';
            to = GUI.$(to);
            to.appendChild(div);
        },

        /**
         * Returns is variable exists
         *
         * @param {Object} varName
         * @returns {Boolean}
         */
        isSet : function (val) {
            return (val !== undefined) && (val !== null);
        },

        /**
         * Returns true if value is undefined
         * @param {String|Number} val
         * @returns {Boolean}
         */
        isUndefined: function (val) {
            return typeof val === 'undefined';
        },

        /**
         * Returns true if value is number
         * @param {Number} val
         * @returns {Boolean}
         */
        isNumber: function (val) {
            return typeof val === 'number';
        },

        /**
         * Returns true if value is boolean
         * @param {Boolean} val
         * @returns {Boolean}
         */
        isBoolean: function (val) {
            return typeof val === 'boolean';
        },

        /**
         * Returns true if value is string
         * @param {String} val
         * @returns {Boolean}
         */
        isString: function (val) {
            return typeof val === 'string';
        },

        /**
         * Returns true if value is function
         * @param {Function} val
         * @returns {Boolean}
         */
        isFunction: function (val) {
            return typeof val === 'function';
        },

        /**
         * Returns true if value is array
         * @param {Array} val
         * @returns {Boolean}
         */
        isArray: function (o) {
            return Object.prototype.toString.call(o) === '[object Array]';
        },

        /**
         * Returns true if value is object
         * @param {Object} val
         * @returns {Boolean}
         */
        isObject: function (object) {
            return typeof object === 'object';
        },

        /**
         * Returns true if value is date
         * @param {Date} val
         * @returns {Boolean}
         */
        isDate: function (object) {
            return object && object.constructor === Date;
        },

        /**
         * Returns true if value is empty
         * @param {Number|String} val
         * @returns {Boolean}
         */
        isEmpty: function (val) {
            return (val === undefined) || (val === null) || (val === false) ||
                (val === 0) || (val === '') || ((val && val.constructor === Array) && (val.length === 0));
        },

        /**
         * Convert array to object
         */
        toArray: Object.toArray,

        /**
         * Returns index of the obj in the array
         * @returns {Number}
         */
        arrayIndexOf: function (arr, obj) {
            var len = arr.length;
            while (len--) {
                if (arr[len] === obj) {
                    return len;
                }
            }
            return -1;
        },

        /**
         * Removes element from the array
         * @param {Array} arr
         * @param {Object} o
         * @returns {Object}
         */
        arrayRemove : function (arr, o) {
            var index = GUI.arrayIndexOf(arr, o);
            if (index !== -1) {
                arr.splice(index, 1);
            }
            return arr;
        },

        /**
         * Retrieves the value ​​of the element of an array
         * @param {Array} arr
         * @param {String} name
         * @returns {Array}
         */
        extractPropertyValues: function (arr, name) {
            var res = [], i, len = arr.length;

            for (i = 0; i < len; i++) {
                res.push(arr[i][name]);
            }
            return res;
        },

        /**
         * Destroys the object
         * @param {Object} obj
         */
        destroyObject: function (obj) {
            var i;
            for (i in obj) {
                if (GUI.isFunction(obj[i])) {
                    obj[i] = null;
                } else {
                    delete obj[i];
                }
            }
        },

        /**
         * Returns value if it is less then max and more then min.
         * Returns min if value less then min.
         * Returns max if value more then max.
         * @param {Number} value
         * @param {Number} min
         * @param {Number} max
         * @returns {Number}
         */
        constrain: function (value, min, max) {
            return Math.min(Math.max(value, min), max);
        },

        /**
         * Returns path of the disabled image
         * @param {String} url
         * @returns {String} path
         */
        getDisabledImageUrl: function (url) {
            if (GUI.isString(url)) {
                return url.replace(/^(.*)\.(jpg|gif|png|jpeg)$/i, '$1-disabled.$2');
            }
        },

        /**
         * Returns path of the hover image
         * @param {String} url
         * @returns {String} path
         */
        getHoverImageUrl: function (url) {
            if (GUI.isString(url)) {
                return url.replace(/^(.*)\.(jpg|gif|png|jpeg)$/i, '$1-hover.$2');
            }
        },

        /**
         * Returns path of the toogled image
         * @param {String} url
         * @returns {String} path
         */
        getToggledImageUrl: function (url) {
            if (GUI.isString(url)) {
                return url.replace(/^(.*)\.(jpg|gif|png|jpeg)$/i, '$1-toggled.$2');
            }
        },

        /**
         * Escapes the passed string for use in a regular expression
         * @param {String} str
         * @returns {String}
         */
        escapeRe : function (s) {
            return s.replace(/([.*+?^${}()|[\]\/\\])/g, "\\$1");
        },

        /**
         * Escapes the passed string for ' and \
         * @param {String} string
         * @returns {String}
         */
        escape : function (string) {
            return string.replace(/('|\\)/g, "\\$1");
        },

        /**
         *
         */
        toQueryString: Object.toQueryString,

        /**
         * Creates span element, add to it html of the elem, and gets it width
         * @param {HTMLElement} elem
         * @param {Array} styles
         */
        measureWidth: function (elem, styles) {
            var width,
                tmp = document.createElement('SPAN'),
                style = tmp.style;

            if (GUI.isSet(styles)) {
                GUI.$(tmp).setStyle(styles);
            }
            style.position = 'absolute';
            style.left = '-10000px';
            style.top = '-10000px';

            document.body.appendChild(tmp);
            if (GUI.isString(elem)) {
                tmp.innerHTML = elem;
            } else if (GUI.isString(elem.innerHTML)) {
                tmp.innerHTML = elem.innerHTML;
            }
            width = tmp.offsetWidth;

            document.body.removeChild(tmp);
            return width;
        },

        /**
         * Formats string. For ex.:
         *  formatString('My name is {0}, i am {1}', 'John', 25)
         * @returns 'My name is John, i am 25'
         */
        formatString: function () {
            var args = Object.toArray(arguments),
                str = args.shift();

            return str.replace(/\{(\d*?)\}/gm, function (match, name) {
                return args[name];
            });
        },

        /**
         * Date manipulation
         * @param {Date} date
         * @param {String} format
         * @returns {String} date
         */
        formatDate: function (date, format) {
            return date.formatDate(format);
        },

        /**
         * Parsing date
         * @param {String} str
         * @param {String} format
         */
        parseDate: function (str, format) {
            if (GUI.isDate(str)) {
                return str;
            }

            if (!format || !str) {
                return null;
            }

            var day, month, year, arStr, arFormat, i,
                delimeter = format.match(/[dmy](\W+)[dmy]/i);

            delimeter = delimeter[1];

            arStr = str.split(delimeter);
            arFormat = format.split(delimeter);
            for (i = 0; i < arFormat.length; i++) {
                switch (arFormat[i]) {
                case 'd': day    = parseInt(arStr[i], 10); break;
                case 'm': month  = parseInt(arStr[i], 10); break;
                case 'Y': year   = parseInt(arStr[i], 10); break;
                case 'y': year   = parseInt(arStr[i], 10); break;
                }
            }
            if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                return new Date(year, month - 1, day);
            }
            return false;
        },

        /**
         * Color manipulation.
         * Converts a number to a 2 digit hex string
         * @param {Number} number
         */
        toColorPart: function (number) {
            if (number > 255) {
                number = 255;
            }
            var digits = number.toString(16);
            if (number < 16) {
                return '0' + digits;
            }
            return digits;
        },

        /**
         * Parsing color
         * @param {String} string  Color
         */
        parseColor: function (string) {
            var match, part, i,
                color = '';

            if (match = _rgbRe.exec(string)) {
                for (i = 1; i <= 3; i++) {
                    part = Math.max(0, Math.min(255, parseInt(match[i], 10)));
                    color += GUI.toColorPart(part);
                }
                return color;
            }
            if (match = _hexRe.exec(string)) {
                if (match[1].length === 3) {
                    for (i = 0; i < 3; i++) {
                        color += match[1].charAt(i) + match[1].charAt(i);
                    }
                    return color;
                }
                return match[1];
            }
            return false;
        },

        /**
         * Removes content of the node
         * @param {HTMLElement} node
         */
        clean: function (node) {
            var p;
            while (p = node.firstChild) {
                node.removeChild(p);
            }
        },

        /**
         *
         */
        getFly: function () {
            if (!GUI._flyEl) {
                var node = document.createElement('div');
                node.style.display = 'none';
                node.id = 'jsgui-flyel';
                document.body.appendChild(node);
                GUI._flyEl = node;
            }
            return GUI._flyEl;
        },

        /**
         *
         */
        getFlyOff: function () {
            if (!GUI._flyOffEl) {
                GUI._flyOffEl = document.createElement('div');
                GUI._flyOffEl.id = 'jsgui-flyoffel';
            }
            return GUI._flyOffEl;
        },

        /**
         *
         */
        destroyNode: function (node) {
            if (!GUI.isIE) {
                return GUI.remove(node);
            }

            if (node.parentNode) {
                node.parentNode.removeChild(node);
            }
            var _node, _cont,
                _destroyNode = node;

            switch (node.nodeName) {
            case 'TD':
            case 'TH':
                _destroyNode = _cont = document.createElement('table');

                _node = document.createElement('tbody');
                _cont = _cont.appendChild(_node);

                _node = document.createElement('tr');
                _cont = _cont.appendChild(_node);

                _cont.appendChild(node);
                break;
            case 'TR':
                _destroyNode = _cont = document.createElement('table');

                _node = document.createElement('tbody');
                _cont = _cont.appendChild(_node);

                _cont.appendChild(node);
                break;
            case 'THEAD':
            case 'TBODY':
            case 'TFOOT':
                _destroyNode = _cont = document.createElement('table');

                _cont.appendChild(node);
                break;

            default:
                break;
            }

            try {
                _destroyNode.outerHTML = '';
            } catch (e) {
                if (console && console.log) {
                    console.log(e);
                    console.log('gui.js 839');
                }
            }

            _destroyNode = node = _node = _cont = null;
        },

        /**
         * Removes element from the dom
         * @param {HTMLElement} element
         */
        remove: function (element) {
            element = GUI.$(element);
            var parent = element.parentNode;
            if (parent) {
                parent.removeChild(element);
            }
        },

        /**
         * Replaces the old node to the new
         * @param {HTMLElement} old Old node
         * @param {HTMLElement} replace New node
         */
        replace: function (old, replace) {
            old.parentNode.replaceChild(replace, old);
            GUI.destroyNode(old);
            old = replace = null;
        },

        /**
         * Shows element
         * @param {HTMLElement} elem
         */
        show: function (elem) {
            elem = GUI.$(elem);
            elem.style.display = '';
        },

        /**
         * Hides element
         * @param {HTMLElement} elem
         */
        hide: function (elem) {
            elem = GUI.$(elem);
            elem.style.display = 'none';
        },

        /**
         * Sets display to reverse value
         * @param {HTMLElement} elem
         */
        toggle: function (elem) {
            var style = GUI.$(elem).style;
            style.display = (style.display === 'none') ? '' : 'none';
        },

        /**
         * Returns true if style display of the element is 'none'
         * @param {HTMLElement} elem
         * @returns {Boolean}
         */
        isHidden: function (elem) {
            elem = GUI.$(elem);
            return (elem.style.display === 'none');
        },

        /**
         * Forces the browser to repaint node
         * @param {HTMLElement} node
         */
        repaint : function (node) {
            GUI.Dom.addClass(node, 'x-repaint');
            setTimeout(function () {
                GUI.Dom.removeClass(node, 'x-repaint');
            }, 0);
        },

        /**
         * Sets the node as not selectable for IE
         * @param {HTMLElement} node
         */
        unselectable_IE: function (node) {
            node = GUI.$(node);
            node.unselectable = "on";
            node.on("selectstart", blockSelectionHandler);
            //node.addClass("x-unselectable");
        },

        /**
         * Sets the node as not selectable for other browsers
         * @param {HTMLElement} node
         */
        unselectable_Other: function (node) {
            node = GUI.$(node);
            var s = node.style;
            s.MozUserSelect = 'none';
            s.KhtmlUserSelect = 'none';
            s.WebkitUserSelect = 'none';
        },

        /**
         * Returns state of the value selectable
         * @param {HTMLElement} node
         * @returns {Boolean}
         */
        unselectable : function (node) {
            GUI.unselectable = GUI.isIE ? GUI.unselectable_IE : GUI.unselectable_Other;
            return GUI.unselectable(node);
        },

        /**
         * Create element input
         * @param {String} name
         * @returns {HTMLElement}
         */
        createInput: function (name) {
            var hidden;
            if (GUI.isString(name) && name.length) {
                hidden = document.createElement('input');
                hidden.name = name;
            } else {
                hidden = document.createElement('input');
            }
            return hidden;
        },

        /**
         * Clears container node from childs and then appends one
         * @param {Object} container container node
         * @param {Object} node node to render into container
         */
        renderIntoContainer: function (container, node) {
            container.appendChild(node);
        },

        /**
         *
         */
        _contains_IE: function (container, containee) {
            if (!containee || !container) {
                return false;
            }
            return container.contains(containee);
        },

        /**
         *
         */
        _contains_Gecko: function (container, containee) {
            if (!containee || !container) {
                return false;
            }
            return !!(container.compareDocumentPosition(containee) & 16);
        },

        /**
         *
         */
        _contains_Emulation: function (container, containee) {
            if (!containee || !container) {
                return false;
            }
            var parent = containee,
                c = 10; // limit to 10 nodes to search

            while (parent = parent.parentNode) {
                if (parent === container) {
                    return true;
                } else if (!parent.tagName || (c-- === 0)) {
                    return false;
                }
            }
            return false;
        },

        /**
         * Checks if containee is a child of container.
         * @param {DOMNode} container
         * @param {DOMNode} containee
         */
        contains: function (container, containee) {
            if (container.contains) {
                // IE,
                GUI.contains = GUI._contains_IE;
            } else if (container.compareDocumentPosition) {
                // Gecko (firefox)
                GUI.contains = GUI._contains_Gecko;
            } else {
                // Safari, IE7, Opera and others
                GUI.contains = GUI._contains_Emulation;
            }

            return GUI.contains(container, containee);
        },

        /**
         * Finds element's parent by tag name and optionally class.
         * Traverses parents until reaches document or to element
         * @param {Object} elem
         * @param {Object} tagName
         * @param {Object} to
         * @param {Object} className
         */
        findParentByTag: function (elem, tagName, to, className) {
            to = to || document.body;
            tagName = tagName.toUpperCase();
            if (className) {
                return GUI._findParentByTagAndClass(elem, tagName, to, className);
            } else {
                return GUI._findParentByTag(elem, tagName, to);
            }
        },

        findParentByClassName: function (elem, to, className) {
            to = to || document.body;
            while (elem && (elem !== to)) {
                if (!elem.tagName) {
                    return false;
                }

                if (GUI.Dom.hasClass(elem, className)) {
                    return elem;
                }

                elem = elem.parentNode;
            }
            return false;
        },

        /**
         *
         */
        _findParentByTag: function (elem, tagName, to) {
            while (elem && (elem !== to)) {
                if (!elem.tagName) {
                    return false;
                }
                if (elem.nodeName === tagName) {
                    return elem;
                }
                elem = elem.parentNode;
            }
            return false;
        },

        /**
         *
         */
        _findParentByTagAndClass: function (elem, tagName, to, className) {
            while (elem && (elem !== to)) {
                if (!elem.tagName) {
                    return false;
                }
                if (elem.nodeName === tagName) {
                    if (GUI.Dom.hasClass(elem, className)) {
                        return elem;
                    }
                }
                elem = elem.parentNode;
            }
            return false;
        },

        /* What to do if border-width is a string, like 'normal' or 'medium' ? */
        /**
         * Returns horizontal border
         * @param {HTMLElement} element
         * @returns {Number}
         */
        getHorizontalBorders: function (element) { // slow
            var lBorder, rBorder;

            element = GUI.$(element);

            lBorder = (element.getStyle('border-left-style') !== 'none') ?
                    getDim(element.getStyle('border-left-width')) : 0;
            rBorder = (element.getStyle('border-right-style') !== 'none') ?
                    getDim(element.getStyle('border-right-width')) : 0;
            return lBorder + rBorder;
        },

        /**
         * Returns vertical border
         * @param {HTMLElement} element
         * @returns {Number}
         */
        getVerticalBorders: function (element) {
            element = GUI.$(element);
            var tBorder, bBorder;

            tBorder = (element.getStyle('border-top-style') !== 'none') ?
                    getDim(element.getStyle('border-top-width')) : 0;
            bBorder = (element.getStyle('border-bottom-style') !== 'none') ?
                    getDim(element.getStyle('border-bottom-width')) : 0;
            return tBorder + bBorder;
        },

        /**
         * Returns horizontal padding
         * @param {HTMLElement} element
         * @returns {Number}
         */
        getHorizontalPadding: function (element) { // slow
            var lPadding, rPadding;

            element = GUI.$(element);
            lPadding = getDim(element.getStyle('padding-left'));
            rPadding = getDim(element.getStyle('padding-right'));

            return lPadding + rPadding;
        },

        /**
         * Returns vertical padding
         * @param {HTMLElement} element
         * @returns {Number}
         */
        getVerticalPadding: function (element) {
            var tPadding, bPadding;
            element = GUI.$(element);
            tPadding = getDim(element.getStyle('padding-top'));
            bPadding = getDim(element.getStyle('padding-bottom'));
            return tPadding + bPadding;
        },

        /**
         *
         */
        _stripAlpha: function (filter) {
            return filter.replace(_alphaRe, '');
        },

        /**
         *
         */
        setOpacity_IE: function (element, value) {
            var filter, style,
                currentStyle = element.currentStyle;

            if ((currentStyle && !currentStyle.hasLayout) ||
                    (!currentStyle && element.style.zoom === 'normal')) {
                element.style.zoom = 1;
            }

            filter = element.style.filter;
            style = element.style;

            if (value === '') {
                if (filter = GUI._stripAlpha(filter)) {
                    style.filter = filter;
                } else {
                    style.removeAttribute('filter');
                }
                return element;
            } else if (value < 0.00001) {
                value = 0;
            }

            style.filter = GUI._stripAlpha(filter) + 'alpha(opacity=' + (value * 100) + ')';
            return element;
        },

        /**
         *
         */
        setOpacity_Other: function (element, value) {
            element.style.opacity = (value === '') ? '' : (value < 0.00001) ? 0 : value;
            return element;
        },

        /**
         *
         */
        setOpacity: function (element, value) {
            GUI.setOpacity = (GUI.isIE && !GUI.isIE10 && !GUI.isIE11) ? GUI.setOpacity_IE : GUI.setOpacity_Other;
            return GUI.setOpacity(element, value);
        },

        /**
         * Returns event's target
         * @param {Object} e
         */
        getEventTarget: function (e) {
            var targ = e.target || e.srcElement;
            return GUI.isSafari && targ && (3 === targ.nodeType)
                ? targ = targ.parentNode
                : targ;
        },

        /**
         *
         */
        getRelatedTarget: function (evt) {
            if (evt.type === 'mouseover') {
                return evt.relatedTarget || evt.fromElement;
            } else if (evt.type === 'mouseout') {
                return evt.relatedTarget || evt.toElement;
            } else {
                throw new Error("getRelatedTarget can be called only for mover/mout");
            }
        },

        /**
         *
         */
        preventDefault: function (e) {
            if (GUI.isIE) {
                e.returnValue = false;
            } else {
                e.preventDefault();
            }
        },

        /**
         *
         */
        stopPropagation: function (e) {
            if (GUI.isIE) {
                e.cancelBubble = true;
            } else {
                e.stopPropagation();
            }
        },

        /**
         *
         */
        stopEvent: function (e) {
            GUI.stopPropagation(e);
            GUI.preventDefault(e);
        },

        /**
         *
         */
        cloneEvent: function (evt) {
            var e = {};
            Object.extend(e, evt);
            return e;
        },

        /**
         * onMouseEnter emulation
         * @param {Object} node
         * @param {Object} evt
         */
        isMouseEnter: function (node, evt) {
            var relTarget = evt.relatedTarget || evt.fromElement;
            return !((node === relTarget) || GUI.contains(node, relTarget));
        },

        /**
         * onMouseLeave emulation
         * @param {Object} node
         * @param {Object} evt
         */
        isMouseLeave: function (node, evt) {
            var relTarget = evt.relatedTarget || evt.toElement;
            return !((node === relTarget) || GUI.contains(node, relTarget));
        },

        /**
         * Private function
         * @param {Object} event
         * @param {Object} code
         */
        isButton: function (event, code) {
            if (GUI.isIE) {
                var buttonMap = {0: 1, 1: 4, 2: 2};
                GUI.isButton = function (event, code) {
                    return event.button === buttonMap[code];
                };
            } else if (GUI.isSafari) {
                GUI.isButton = function (event, code) {
                    switch (code) {
                    case 0: return event.which === 1 && !event.metaKey;
                    case 1: return event.which === 1 && event.metaKey;
                    default: return false;
                    }
                };
            } else {
                GUI.isButton = function (event, code) {
                    return event.which ? (event.which === code + 1) : (event.button === code);
                };
            }

            return GUI.isButton(event, code);
        },

        /**
         *
         */
        isLeftClick:   function (event) {return GUI.isButton(event, 0); },

        /**
         *
         */
        isMiddleClick: function (event) {return GUI.isButton(event, 1); },

        /**
         *
         */
        isRightClick:  function (event) {return GUI.isButton(event, 2); },

        /**
         * Check if navigational key pressed
         * @param {Object} event
         */
        isNavKeyPress: function (event) {
            var k = event.keyCode;
            return (k >= 33 && k <= 40) || k === Event.KEY_RETURN || k === Event.KEY_TAB || k === Event.KEY_ESC;
        },

        /**
         *
         */
        pointerXY: function (event) {
            return {
                x: event.pageX || (event.clientX +
                  (document.documentElement.scrollLeft || document.body.scrollLeft)),
                y: event.pageY || (event.clientY +
                  (document.documentElement.scrollTop || document.body.scrollTop))
            };
        },

        /**
         *
         */
        makeVisible: function (node) {
            // Goes up on the dom tree and unhides hidden nodes via style display none
            var len, elem, style,
                hiddenNodes = [],
                p = node;

            while (p && p.tagName) {
                if (GUI.isHidden(p)) {
                    hiddenNodes.push(p);
                }
                p = p.parentNode;
            }
            len = hiddenNodes.length;

            if (len-- > 0) {
                elem = hiddenNodes[len];
                style = elem.style;
                node._oldposition   = style.position;
                node._olddisplay    = style.display;
                node._oldleft       = style.left;
                node._oldtop        = style.top;
                node._olddisplay    = style.display;
                style.position      = 'absolute';
                style.display       = 'block';
                style.left          = '-10000px';
                style.top           = '-10000px';
            }
            while (len-- > 0) {
                GUI.show(hiddenNodes[len]);
            }
            node._cacheId = GUI.getUniqId('tmp-');
            undoCache[node._cacheId] = hiddenNodes;
        },

        /**
         *
         */
        undoVisible: function (node) {
            var style, elem,
                hiddenNodes = undoCache[node._cacheId],
                len = hiddenNodes.length;

            if (len-- > 0) {
                elem = hiddenNodes[len];
                style = elem.style;
                style.display       = node._olddisplay;
                style.position      = node._oldposition;
                style.left          = node._oldleft;
                style.top           = node._oldtop;
                node._olddisplay    = undefined;
                node._oldposition   = undefined;
                node._oldleft       = undefined;
                node._oldtop        = undefined;
            }
            while (len-- > 0) {
                GUI.hide(hiddenNodes[len]);
            }
            delete undoCache[node._cacheId];
            node._cacheId = null;
        },

        /**
         * Returns client width of the node
         * @param {HTMLElement} node
         * @returns {Number} width
         */
        getClientWidth: function (node) {
            GUI.makeVisible(node);
            var w = node.clientWidth;
            GUI.undoVisible(node);
            return w;
        },

        /**
         * Returns client height of the node
         * @param {HTMLElement} node
         * @returns {Number} height
         */
        getClientHeight: function (node) {
            GUI.makeVisible(node);
            var h = GUI.getInnerHeight(node);
            GUI.undoVisible(node);
            return h;
        },

        /**
         * Returns full width of the node
         * @param {HTMLElement} node
         * @returns {Number} width
         */
        getFullWidth: function (node) {
            var w = GUI.getDimensions(node).width;
            return w;
        },

        /**
         * Returns full height of the node
         * @param {HTMLElement} node
         * @returns {Number} height
         */
        getFullHeight: function (node) {
            var h = GUI.getDimensions(node).height;
            return h;
        },

        /**
         *
         */
        runDomVisible: function (element, wasVisibleCb, wasHiddenCb) {
            element = GUI.$(element);
            var els, originalPosition, originalDisplay, res,
                display = GUI.$(element).getStyle('display');
            if (display !== 'none' && display !== null) { // Safari bug
                if (GUI.isFunction(wasVisibleCb)) {
                    return wasVisibleCb(element);
                } else {
                    return;
                }
            }
            wasHiddenCb = wasHiddenCb || wasVisibleCb;
            if (!GUI.isFunction(wasHiddenCb)) {
                return;
            }

            els = element.style;
            originalPosition    = els.position;
            originalDisplay     = els.display;
            els.position        = 'absolute';
            els.display         = 'block';
            els.display         = originalDisplay;
            els.position        = originalPosition;

            res = wasHiddenCb(element);
            return res;
        },

        /**
         * Returns dimensions of the element
         * @param {HTMLElement} element
         * @returns {Object}
         */
        _getDimensions: function (element) {
            return {
                width  : element.offsetWidth,
                height : element.offsetHeight
            };
        },

        /**
         * Returns dimensions of the element
         * @param {HTMLElement} element
         * @returns {Object}
         */
        getDimensions: function (node, forceVisible) {
            var f, res;
            if (!forceVisible) {
                return {
                    width  : node.offsetWidth,
                    height : node.offsetHeight
                };
            }
            f = GUI._getDimensions;

            if (forceVisible === 'deep') {
                GUI.makeVisible(node);
                res = f(node);
                GUI.undoVisible(node);
                return res;
            }

            return GUI.runDomVisible(node, f, f);
        },

        /**
         * Returns dimensions of the element
         * @param {HTMLElement} elem
         * @returns {Object}
         */
        getClientSize: function (elem) {
            if (elem === document || elem === document.body) {
                return {
                    width  : GUI.getViewportWidth(),
                    height : GUI.getViewportHeight()
                };
            }
            return {
                width  : elem.clientWidth,
                height : elem.clientHeight
            };
        },

        /**
         * Sets width
         * @param {HTMLElement} element
         * @param {Number} width
         */
        setFullWidth: function (element, width) { // slow
            var padding, borders, clientWidth;

            element = GUI.$(element);
            if (GUI.isString(width) && width.endsWith('%')) {
                element.style.width = width;
                return;
            }
            clientWidth = width;

            if (!GUI.isBorderBox) {
                padding = GUI.getHorizontalPadding(element); // twice slow as border
                borders = GUI.getHorizontalBorders(element); // 10ms/call
                clientWidth -= padding + borders;
                if (clientWidth < 0) {
                    clientWidth = 0;
                }
            }
            element.style.width = clientWidth.toString() + 'px';
        },

        /**
         * Sets height
         * @param {HTMLElement} e Element
         * @param {Number} v Height
         */
        setClientHeight: function (e, v) {
            if (GUI.isBorderBox) {
                v += GUI.getVerticalPadding(e) + GUI.getVerticalBorders(e);
            }
            if (v < 0) {
                console.log('Can not set such height because of padding or borders');
                v = 0;
            }
            e.style.height = v + 'px';
        },

        /**
         * Sets width
         * @param {HTMLElement} e Element
         * @param {Number} v Width
         */
        setClientWidth: function (e, v) {
            if (GUI.isBorderBox) {
                v += GUI.getHorizontalPadding(e) + GUI.getHorizontalBorders(e);
            }
            if (v < 0) {
                console.log('Can not set such width because of padding or borders');
                v = 0;
            }
            e.style.height = v + 'px';
        },

        /**
         * Sets height
         * @param {HTMLElement} element
         * @param {Number} height
         */
        setFullHeight: function (element, height) {
            var clientHeight, padding, borders;
            element = GUI.$(element);
            if (GUI.isString(height) && height.endsWith('%')) {
                element.style.height = height;
                return;
            }
            height = parseInt(height, 10);
            if (height < 0) {
                //throw new Error('setting negative height!!');
                console.log('trying to set negative height!!', element, height);
                height = 0;
            }
            clientHeight = height;
            if (!GUI.isBorderBox) {
                padding = GUI.getVerticalPadding(element);
                borders = GUI.getVerticalBorders(element);
                clientHeight -= padding + borders;
                if (clientHeight < 0) {
                    clientHeight = 0;
                }
            }

            element.style.height = clientHeight.toString() + 'px';
        },

        /**
         * Gets width of viewable part of document
         * @returns {Number} width
         */
        getViewportWidth: function () {
            return GUI.isStrict ? document.documentElement.clientWidth : document.body.clientWidth;
        },

        /**
         * Gets height of viewable part of document
         * @returns {Number} height
         */
        getViewportHeight: function () {
            if (GUI.isIE) {
                return GUI.isStrict ? document.documentElement.clientHeight : document.body.clientHeight;
            } else {
                return self.innerHeight;
            }
        },

        /**
         * Returns width of the document
         * @returns {Number} width
         */
        getDocumentWidth: function () {
            var w = GUI.isStrict ? document.documentElement.scrollWidth : document.body.scrollWidth;
            return Math.max(w, GUI.getViewportWidth()) - 1;
        },

        /**
         * Returns height of the document
         * @returns {Number} height
         */
        getDocumentHeight: function () {
            var h = GUI.isStrict ? document.documentElement.scrollHeight : document.body.scrollHeight;
            return Math.max(h, GUI.getViewportHeight());
        },

        /**
         * Retruns inner height
         * @param {HTMLElement} element
         * @returns {Number} height
         */
        getInnerHeight: function (element) {
            var tPadding, bPadding, tBorder, bBorder;

            element = GUI.$(element);
            tPadding = getDim(element.getStyle('padding-top'));
            bPadding = getDim(element.getStyle('padding-bottom'));
            tBorder = getDim(element.getStyle('border-top-width'));
            bBorder = getDim(element.getStyle('border-bottom-width'));

            return element.offsetHeight - tPadding - bPadding - tBorder - bBorder;
        },

        /**
         * Gets height of the node
         * @param {HTMLElement} elem
         * @returns {Number} height
         */
        getInnerNodesHeight: function (elem) {
            var h = 0,
                i = elem.childNodes.length;
            while (i--) {
                h += parseInt(elem.childNodes[i].offsetHeight, 10);
            }
            return h;
        },

        /**
         * Returns the current scroll position of the element.
         * @param {HTMLElement} elem
         * @return {Object} An object containing the scroll position in the format
         *  {left: (scrollLeft), top: (scrollTop)}
         */
        getScroll : function (elem) {
            var l, t,
                d = elem,
                doc = elem.ownerDocument,
                docEl = doc.documentElement,
                body = doc.body;

            if ((d === docEl) || (d === body)) {
                if (GUI.isIE && GUI.isStrict) {
                    l = docEl.scrollLeft || (body.scrollLeft || 0);
                    t = docEl.scrollTop || (body.scrollTop || 0);
                } else {
                    l = window.pageXOffset || (body.scrollLeft || 0);
                    t = window.pageYOffset || (body.scrollTop || 0);
                }
                return {left: l, top: t};
            } else {
                return {left: d.scrollLeft, top: d.scrollTop};
            }
        },

        /**
         *
         */
        getScrollableContainer: function (elem) {
            var parent = elem.parentNode;

            while (parent) {
                if (GUI.$(parent).getStyle('overflow') === null) {
                    return parent;
                } else if (!parent.tagName || parent.tagName.toUpperCase() === "HTML") {
                    return false;
                }
                parent = parent.parentNode;
            }
            return false;
        },

        /**
         *
         */
        getTotalScroll: function (element, to) {
            to = to || document.body;
            var left = 0,
                top = 0,
                parent = element.parentNode;

            while (parent) {
                if ((parent === to) || !parent.tagName || (parent.tagName === 'HTML')) {
                    break;
                }
                if (!GUI.isOpera ||
                        ((parent.nodeName !== 'TR') &&
                            (GUI.Dom.getStyle(parent, 'display') !== 'inline'))) {
                    left += parent.scrollLeft;
                    top += parent.scrollTop;
                }
                if (GUI.Dom.getStyle(parent, 'position') === 'absolute') {
                    break;
                }
                parent = parent.parentNode;
            }
            return [left, top];
        },

        /**
         *
         */
        scrollIntoView: function (cont, elem, dir) {
            dir = dir || 'vh';

            var relLeft, elemLeft, elemWidth, contWidth,
                relTop, elemTop, elemHeight, contHeight,
                p1 = GUI.getPosition(elem),
                p2 = GUI.getPosition(cont);

            if (dir.indexOf('h') > -1) {
                relLeft = p1.left - p2.left + cont.scrollLeft;
                elemLeft = relLeft - cont.clientLeft;
                elemWidth    = elem.offsetWidth;
                contWidth    = cont.clientWidth;

                // Scroll horizontally
                if ((elemLeft < 0) || (elemWidth > contWidth)) {
                    // element is lefter, than current view, show it at the left
                    // or if element is and wider, than view, also show at left
                    cont.scrollLeft = elemLeft;
                } else if (elemLeft + elemWidth > contWidth) {
                    // element is righter, than current view, show it at the right
                    cont.scrollLeft = elemLeft + elemWidth - contWidth;
                }
            }

            if (dir.indexOf('v') > -1) {
                relTop = p1.top - p2.top + cont.scrollTop;
                elemTop = relTop - cont.clientTop;
                elemHeight  = elem.offsetHeight;
                contHeight  = cont.clientHeight;

                if (elemTop < cont.scrollTop) {
                    // element is higher, than current view, show it at the top
                    cont.scrollTop = elemTop;
                } else if (elemTop + elemHeight > cont.scrollTop + contHeight) {
                    // element is lower, than current view, show ia at the bottom
                    cont.scrollTop = elemTop + elemHeight - contHeight;
                }
            }

            if (dir === 'top') {
                relTop = p1.top - p2.top + cont.scrollTop;
                elemTop = relTop - cont.clientTop;
                //
                cont.scrollTop = elemTop;
            }
        },

        /**
         * Scrolls to element if it behind the viewport
         * @param {HTMLElement} el
         */
        scrollIntoBehindTheViewportElement: function (el) {
            var posEl, pos2El, dimEl, cont, dimCont,
                scrollCont = 0;

            posEl = this.getPosition(el, true);
            dimEl = this.getDimensions(el, true);

            pos2El = [posEl[0] + dimEl.width, posEl[1] + dimEl.height];

            cont = this.getScrollableContainer(el);
            dimCont = this.getDimensions(cont);

            if (!cont) {
                cont = document.body;
                dimCont.height = this.getViewportHeight();
                scrollCont = this.getScroll(cont).top;
            }

            if ((pos2El[1] - scrollCont) > dimCont.height) {
                el.scrollIntoView(false);
            }
        },

        /**
         *
         */
        _getPosition: function (element) {
            var d, scroll, docEl, body, b, parent, res,
                top = 0,
                left = 0;

            if (element.getBoundingClientRect && !ie11) {
                d = element.ownerDocument;
                docEl = d.documentElement;
                body = d.body;
                b = element.getBoundingClientRect();

                left = Math.round(b.left);
                top = Math.round(b.top);

                left -= docEl.clientLeft || body.clientLeft || 0;
                top -= docEl.clientTop || body.clientTop || 0;

                scroll = GUI.getScroll(docEl);

                left += scroll.left;
                top  += scroll.top;

                res = [left, top];
                res.left = left;
                res.top = top;
                return res;
            }

            d = element.ownerDocument;
            body = d.body;
            docEl = d.documentElement;
            parent = element;
            top = element.offsetTop;
            left = element.offsetLeft;

            while ((parent = parent.offsetParent) && parent !== body && parent !== docEl) {
                if (GUI.isOpera && (parent.tagName === 'TD')) {
                    continue;
                } else {
                    top += parent.offsetTop || 0;
                    left += parent.offsetLeft || 0;
                }
            }

            scroll = GUI.getTotalScroll(element);
            left   -= scroll[0];
            top    -= scroll[1];

            res = [left, top];
            res.left = left;
            res.top = top;

            return res;
        },

        /**
         *
         */
        getPosition: function (node, forceVisible) {
            if (!forceVisible) {
                return GUI._getPosition(node);
            }
            return GUI.runDomVisible(node, GUI._getPosition);
        },

        /**
         *
         */
        getLocalCoordinates: function (elem, xy) {
            // xy coordinates are relative to document.body
            // get absolute coordinates of offsetParent and subtract them

            var elemPos, offParent, res;
            if ((elem === document) || (elem === document.body) || (!elem.offsetParent)) {
                return xy;
            }
            elemPos = GUI.Dom.getStyle(elem, 'position');
            if (elemPos !== 'relative' && elemPos !== 'absolute') {
                offParent = GUI.getPosition(elem.offsetParent, true);
            } else {
                offParent = GUI.getPosition(elem, true);
            }

            res = [];
            res[0] = xy[0] - offParent[0];
            res[1] = xy[1] - offParent[1];
            res.left = res[0];
            res.top = res[1];
            return res;
        },

        /**
         *
         */
        getRelativeOffset: function (elem, cont) {
            var p1 = GUI.getPosition(elem, true),
                p2 = GUI.getPosition(cont, true);

            return [p1.left - p2.left, p1.top - p2.top];
        },

        /**
         *
         */
        registerObject: function (obj) {
            GUI._registeredObjects[GUI._registeredObjectsIdx++] = obj;
        },

        /**
         *
         */
        destroyObjects: function () {
            var i, obj;
            GUI.Event.removeAll();
            for (i = 0; i < GUI._registeredObjectsIdx; i++) {
                obj = GUI._registeredObjects[i];
                if (obj.purgeListeners) {
                    obj.purgeListeners();
                }
                GUI.destroyObject(obj);
            }
        },

        /**
         *
         */
        _registeredObjects: [],

        /**
         *
         */
        _registeredObjectsIdx: 0,

        /**
         *
         */
        getLocationGetParams: function () {
            var i, pair,
                res = {},
                pairs = window.location.search.substring(1).split('&'),
                len = pairs.length;

            for (i = 0; i < len; i++) {
                pair = pairs[i].split('=', 2);
                res[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }
            return res;
        },

        /**
         *
         */
        _keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_~",

        /**
         * Public method for encoding
         */
        _base64encode : function (input) {
            var chr1, chr2, chr3, enc1, enc2, enc3, enc4,
                output = "",
                i = 0;

            input = this._utf8_encode(input);
            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output = output +
                    this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                    this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
            }
            return output;
        },

        base64_encode: function (data) {
            var o1, o2, o3, h1, h2, h3, h4, bits, r,
                i = 0,
                b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                ac = 0,
                enc = "",
                tmp_arr = [];

            if (!data) {
                return data;
            }

            do { // pack three octets into four hexets
                o1 = data.charCodeAt(i++);
                o2 = data.charCodeAt(i++);
                o3 = data.charCodeAt(i++);

                bits = o1 << 16 | o2 << 8 | o3;

                h1 = bits >> 18 & 0x3f;
                h2 = bits >> 12 & 0x3f;
                h3 = bits >> 6 & 0x3f;
                h4 = bits & 0x3f;

                // use hexets to index into b64, and append result to encoded string
                tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);

            } while (i < data.length);

            enc = tmp_arr.join('');

            r = data.length % 3;

            return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
        },

        /**
         * Public method for decoding
         */
        _base64decode : function (input) {
            var chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0,
                output = "";

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            while (i < input.length) {

                enc1 = this._keyStr.indexOf(input.charAt(i++));
                enc2 = this._keyStr.indexOf(input.charAt(i++));
                enc3 = this._keyStr.indexOf(input.charAt(i++));
                enc4 = this._keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }
            output = this._utf8_decode(output);
            return output;
        },

        base64_decode: function (data) {
            var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
                b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                ac = 0,
                dec = "",
                tmp_arr = [];

            if (!data) {
                return data;
            }

            data += '';

            do { // unpack four hexets into three octets using index points in b64
                h1 = b64.indexOf(data.charAt(i++));
                h2 = b64.indexOf(data.charAt(i++));
                h3 = b64.indexOf(data.charAt(i++));
                h4 = b64.indexOf(data.charAt(i++));

                bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

                o1 = bits >> 16 & 0xff;
                o2 = bits >> 8 & 0xff;
                o3 = bits & 0xff;

                if (h3 == 64) {
                    tmp_arr[ac++] = String.fromCharCode(o1);

                } else if (h4 == 64) {
                    tmp_arr[ac++] = String.fromCharCode(o1, o2);

                } else {
                    tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
                }

            } while (i < data.length);

            dec = tmp_arr.join('');

            return dec;
        },

        b64toBlob: function (b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

              var blob = new Blob(byteArrays, {type: contentType});
              return blob;
        },

        /**
         * Private method for UTF-8 encoding
         */
        _utf8_encode : function (string) {
            string = string.replace(/\r\n/g, "\n");
            var n, c,
                utftext = "";

            for (n = 0; n < string.length; n++) {

                c = string.charCodeAt(n);

                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
            }
            return utftext;
        },

        utf8_encode: function (argString) {
            if (argString === null || typeof argString === "undefined") {
                return "";
            }

            var n, c1, c2, enc, start, end,
                utftext = '',
                string = (argString + ''),
                stringl = 0;

            start = end = 0;
            stringl = string.length;

            for (n = 0; n < stringl; n++) {
                c1 = string.charCodeAt(n);
                enc = null;

                if (c1 < 128) {
                    end++;

                } else if (c1 > 127 && c1 < 2048) {
                    enc = String.fromCharCode(
                        (c1 >> 6)        | 192,
                        ( c1        & 63) | 128
                    );

                } else if ((c1 & 0xF800) != 0xD800) {
                    enc = String.fromCharCode(
                        (c1 >> 12)       | 224,
                        ((c1 >> 6)  & 63) | 128,
                        ( c1        & 63) | 128
                    );

                } else { // surrogate pairs
                    if ((c1 & 0xFC00) != 0xD800) {
                        throw new RangeError("Unmatched trail surrogate at " + n);
                    }

                    c2 = string.charCodeAt(++n);

                    if ((c2 & 0xFC00) != 0xDC00) {
                        throw new RangeError("Unmatched lead surrogate at " + (n-1));
                    }

                    c1 = ((c1 & 0x3FF) << 10) + (c2 & 0x3FF) + 0x10000;
                    enc = String.fromCharCode(
                        (c1 >> 18)       | 240,
                        ((c1 >> 12) & 63) | 128,
                        ((c1 >> 6)  & 63) | 128,
                        ( c1        & 63) | 128
                    );
                }

                if (enc !== null) {

                    if (end > start) {
                        utftext += string.slice(start, end);
                    }
                    utftext += enc;
                    start = end = n + 1;
                }
            }

            if (end > start) {
                utftext += string.slice(start, stringl);
            }

            return utftext;
        },

        /**
         * Private method for UTF-8 decoding
         */
        _utf8_decode : function (utftext) {
            var string = "",
                i = 0,
                c = 0,
                c1 = 0,
                c2 = 0,
                c3 = 0;

            while (i < utftext.length) {

                c = utftext.charCodeAt(i);

                if (c < 128) {
                    string += String.fromCharCode(c);
                    i++;
                } else if ((c > 191) && (c < 224)) {
                    c2 = utftext.charCodeAt(i + 1);
                    string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                    i += 2;
                } else {
                    c2 = utftext.charCodeAt(i + 1);
                    c3 = utftext.charCodeAt(i + 2);
                    string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;
                }
            }
            return string;
        },

        utf8_decode: function (str_data) {
            var tmp_arr = [],
              i = 0,
              ac = 0,
              c1 = 0,
              c2 = 0,
              c3 = 0,
              c4 = 0;

            str_data += '';

            while (i < str_data.length) {
                c1 = str_data.charCodeAt(i);

                if (c1 <= 191) {
                    tmp_arr[ac++] = String.fromCharCode(c1);
                    i++;

                } else if (c1 <= 223) {
                    c2 = str_data.charCodeAt(i + 1);
                    tmp_arr[ac++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
                    i += 2;

                } else if (c1 <= 239) {
                    c2 = str_data.charCodeAt(i + 1);
                    c3 = str_data.charCodeAt(i + 2);
                    tmp_arr[ac++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;

                } else {
                    c2 = str_data.charCodeAt(i + 1);
                    c3 = str_data.charCodeAt(i + 2);
                    c4 = str_data.charCodeAt(i + 3);
                    c1 = ((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63);
                    c1 -= 0x10000;
                    tmp_arr[ac++] = String.fromCharCode(0xD800 | ((c1>>10) & 0x3FF));
                    tmp_arr[ac++] = String.fromCharCode(0xDC00 | (c1 & 0x3FF));
                    i += 4;
                }
            }
            return tmp_arr.join('');
        },

        /**
         *
         * @param {type} table
         * @param {type} quote_style
         * @returns {unresolved}
         */
        get_html_translation_table: function (table, quote_style) {
            var entities = {},
                hash_map = {},
                decimal,
                constMappingTable = {},
                constMappingQuoteStyle = {},
                useTable = {},
                useQuoteStyle = {};

            // Translate arguments
            constMappingTable[0] = 'HTML_SPECIALCHARS';
            constMappingTable[1] = 'HTML_ENTITIES';
            constMappingQuoteStyle[0] = 'ENT_NOQUOTES';
            constMappingQuoteStyle[2] = 'ENT_COMPAT';
            constMappingQuoteStyle[3] = 'ENT_QUOTES';

            useTable = !isNaN(table) ? constMappingTable[table] : table ? table.toUpperCase() : 'HTML_SPECIALCHARS';
            useQuoteStyle = !isNaN(quote_style)
                ?
                    constMappingQuoteStyle[quote_style]
                :
                    quote_style
                        ?
                            quote_style.toUpperCase()
                        :
                            'ENT_COMPAT';

            if (useTable !== 'HTML_SPECIALCHARS' && useTable !== 'HTML_ENTITIES') {
                throw new Error("Table: " + useTable + ' not supported');
            }

            entities['38'] = '&amp;';

            if (useTable === 'HTML_ENTITIES') {
                entities['160'] = '&nbsp;';
                entities['161'] = '&iexcl;';
                entities['162'] = '&cent;';
                entities['163'] = '&pound;';
                entities['164'] = '&curren;';
                entities['165'] = '&yen;';
                entities['166'] = '&brvbar;';
                entities['167'] = '&sect;';
                entities['168'] = '&uml;';
                entities['169'] = '&copy;';
                entities['170'] = '&ordf;';
                entities['171'] = '&laquo;';
                entities['172'] = '&not;';
                entities['173'] = '&shy;';
                entities['174'] = '&reg;';
                entities['175'] = '&macr;';
                entities['176'] = '&deg;';
                entities['177'] = '&plusmn;';
                entities['178'] = '&sup2;';
                entities['179'] = '&sup3;';
                entities['180'] = '&acute;';
                entities['181'] = '&micro;';
                entities['182'] = '&para;';
                entities['183'] = '&middot;';
                entities['184'] = '&cedil;';
                entities['185'] = '&sup1;';
                entities['186'] = '&ordm;';
                entities['187'] = '&raquo;';
                entities['188'] = '&frac14;';
                entities['189'] = '&frac12;';
                entities['190'] = '&frac34;';
                entities['191'] = '&iquest;';
                entities['192'] = '&Agrave;';
                entities['193'] = '&Aacute;';
                entities['194'] = '&Acirc;';
                entities['195'] = '&Atilde;';
                entities['196'] = '&Auml;';
                entities['197'] = '&Aring;';
                entities['198'] = '&AElig;';
                entities['199'] = '&Ccedil;';
                entities['200'] = '&Egrave;';
                entities['201'] = '&Eacute;';
                entities['202'] = '&Ecirc;';
                entities['203'] = '&Euml;';
                entities['204'] = '&Igrave;';
                entities['205'] = '&Iacute;';
                entities['206'] = '&Icirc;';
                entities['207'] = '&Iuml;';
                entities['208'] = '&ETH;';
                entities['209'] = '&Ntilde;';
                entities['210'] = '&Ograve;';
                entities['211'] = '&Oacute;';
                entities['212'] = '&Ocirc;';
                entities['213'] = '&Otilde;';
                entities['214'] = '&Ouml;';
                entities['215'] = '&times;';
                entities['216'] = '&Oslash;';
                entities['217'] = '&Ugrave;';
                entities['218'] = '&Uacute;';
                entities['219'] = '&Ucirc;';
                entities['220'] = '&Uuml;';
                entities['221'] = '&Yacute;';
                entities['222'] = '&THORN;';
                entities['223'] = '&szlig;';
                entities['224'] = '&agrave;';
                entities['225'] = '&aacute;';
                entities['226'] = '&acirc;';
                entities['227'] = '&atilde;';
                entities['228'] = '&auml;';
                entities['229'] = '&aring;';
                entities['230'] = '&aelig;';
                entities['231'] = '&ccedil;';
                entities['232'] = '&egrave;';
                entities['233'] = '&eacute;';
                entities['234'] = '&ecirc;';
                entities['235'] = '&euml;';
                entities['236'] = '&igrave;';
                entities['237'] = '&iacute;';
                entities['238'] = '&icirc;';
                entities['239'] = '&iuml;';
                entities['240'] = '&eth;';
                entities['241'] = '&ntilde;';
                entities['242'] = '&ograve;';
                entities['243'] = '&oacute;';
                entities['244'] = '&ocirc;';
                entities['245'] = '&otilde;';
                entities['246'] = '&ouml;';
                entities['247'] = '&divide;';
                entities['248'] = '&oslash;';
                entities['249'] = '&ugrave;';
                entities['250'] = '&uacute;';
                entities['251'] = '&ucirc;';
                entities['252'] = '&uuml;';
                entities['253'] = '&yacute;';
                entities['254'] = '&thorn;';
                entities['255'] = '&yuml;';
            }

            if (useQuoteStyle !== 'ENT_NOQUOTES') {
                entities['34'] = '&quot;';
            }
            if (useQuoteStyle === 'ENT_QUOTES') {
                entities['39'] = '&#39;';
            }

            entities['60'] = '&lt;';
            entities['62'] = '&gt;';

            // ascii decimals to real symbols
            for (decimal in entities) {
                if (entities.hasOwnProperty(decimal)) {
                    hash_map[String.fromCharCode(decimal)] = entities[decimal];
                }
            }

            return hash_map;
        },

        /**
         *
         * @param {type} string_
         * @param {type} quote_style
         * @param {type} charset
         * @param {type} double_encode
         * @returns {Boolean}
         */
        htmlentities: function (string_, quote_style, charset, double_encode) {
            var symbol = '',
                string = (string_ === null) ? '' : string + '',
                hash_map = this.get_html_translation_table('HTML_ENTITIES', quote_style);

            if (!hash_map) {
                return false;
            }

            if (quote_style && quote_style === 'ENT_QUOTES') {
                hash_map["'"] = '&#039;';
            }

            if (!!double_encode || double_encode == null) {
                for (symbol in hash_map) {
                    if (hash_map.hasOwnProperty(symbol)) {
                        string = string.split(symbol).join(hash_map[symbol]);
                    }
                }
            } else {
                string = string.replace(/([\s\S]*?)(&(?:#\d+|#x[\da-f]+|[a-zA-Z][\da-z]*);|$)/g,
                    function (ignore, text, entity) {
                        for (symbol in hash_map) {
                            if (hash_map.hasOwnProperty(symbol)) {
                                text = text.split(symbol).join(hash_map[symbol]);
                            }
                        }
                        return text + entity;
                    }
                );
            }
            return string;
        },

        /**
         *
         * @param {type} string
         * @param {type} quote_style
         * @returns {Boolean}
         */
        html_entity_decode: function(string, quote_style) {
            var hash_map = {},
                symbol = '',
                tmp_str = '',
                entity = '';
                tmp_str = string.toString();

            if (false === (hash_map = this.get_html_translation_table('HTML_ENTITIES', quote_style))) {
                return false;
            }

            delete(hash_map['&']);
            hash_map['&'] = '&amp;';

            for (symbol in hash_map) {
                entity = hash_map[symbol];
                tmp_str = tmp_str.split(entity).join(symbol);
            }
            tmp_str = tmp_str.split('&#039;').join("'");

            return tmp_str;
        },

        setCookie: function(name, value, expires, path, domain, secure) {
            if (typeof expires === 'string' && (/^\d+$/).test(expires)) {
                expires = parseInt(expires, 10);
            }

            if (expires instanceof Date) {
                expires = expires.toGMTString();

            } else if (typeof(expires) === 'number') {
                expires = (new Date(expires * 1e3)).toGMTString();
            }

            var r = [name + '=' + encodeURIComponent(value)],
                s = {},
                i = '';

            s = {
                expires : expires,
                path    : path,
                domain  : domain
            };

            for (i in s) {
                if (s.hasOwnProperty(i)) { // Exclude items on Object.prototype
                    s[i] && r.push(i + '=' + s[i]);
                }
            }

            return secure && r.push('secure'), window.document.cookie = r.join(";"), true;
        },

        getCookie: function(name) {
            var matches = window.document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },

        deletecookie: function(name) {
            this.setCookie(name, null, -1);
        },

        getCss3Property: function (property) {
            var div, style, prop, Prop;

            div = document.createElement('div');
            style = div.style;

            prop = property.toLowerCase();
            Prop = prop.capitalize();

            return (prop in style) || ('moz' + Prop in style) || ('webkit' + Prop in style) || ('o' + Prop in style) || 'ms' + Prop in style;
        }

    }); // End of GUI extension

    if (window.debugJs || window.debug) {
        GUI.assert = function (cond, msg) {
            if (!cond) {
                console.log('Assertion failed: ' + msg);
            }
        };
    } else {
        GUI.assert = GUI.emptyFunction;
    }

    if (GUI.ElementExtensions) {
        GUI.$ = function (elem) {
            if (typeof elem === 'string') {
                elem = document.getElementById(elem);
            }
            return elem;
        };
    } else {
        GUI.$ = function (elem, raw) {
            if (typeof elem === 'string') {
                elem = document.getElementById(elem);
            }
            return elem ? (raw ? elem : GUI.Dom.extend(elem)) : null;
        };
    }

    // StringBuffer
    if (GUI.isIE) {
        StringBuffer = function (str) {
            this.buf = [];
            this.length = 0;

            if (GUI.isSet(str)) {
                this.append(str);
            }
        };

        StringBuffer.prototype = {
            append: function (str) {
                this.buf[this.length++] = str;
                return this;
            },

            clear: function () {
                this.buf = [];
                this.length = 0;
                return this;
            },

            toString: function () {
                return this.buf.join('');
            }
        };
    } else {
        StringBuffer = function (str) {
            this.buf = (GUI.isSet(str)) ? str : '';
        };

        StringBuffer.prototype = {
            append: function (str) {
                this.buf += str;
                return this;
            },

            clear: function () {
                this.buf = '';
                return this;
            },

            toString: function () {
                return this.buf;
            }
        };
    }
    GUI.StringBuffer = StringBuffer;
}());


/**
 * Remove background images flicker
 */
if (GUI.isIE6) {
    try {
        document.execCommand("BackgroundImageCache", false, true);
    } catch (e) {}
}

Prototype = {
    Browser: {
        IE : GUI.isIE
    }
};

/**
 * Init i18n
 */
//wrap.i18n.init(undefined, 'GUI', {GUI: GUIi18n});
wrap.i18n.init(undefined, 'GUI');

/**
 *
 */
GUI.profile = function (func, scope) {
    var time = new Date() - 0;
    if (func) {
        func.call(scope);
    } else {
        console.log(arguments);
    }
    time = new Date() - time;
    console.log(time + ' ms');
};

/**
 *
 */
GUI.getWidth = function () {
    if (parseInt(navigator.appVersion, 10) > 3) {
        if (navigator.appName === "Netscape") {
            return window.innerWidth;
        }
        if (navigator.appName.indexOf("Microsoft") !== -1 && document.body) {
            return document.body.offsetWidth;
        }
    }
};

/**
 *
 * @param {type} img_
 * @returns {undefined}
 */
GUI.getNameFromFileSrc = function (src) {
    return decodeURIComponent(src.replace(/.*[\/|\\](.*)/, '$1'));
};

/**
 *
 */
GUI.showPreview = function (img, name) {
    var previeImg, previewDlg, contentDom, toolbar;

    if (!img.src) {
        console.log('no source in image');
        console.log(img);
        return;
    }

    toolbar = new GUI.ToolBar({
        background: false,
        align     : 'center',
        extraClass: 'preview-popup-toolbar',
        elements: [{
            name: 'voiting',
            obj: new GUI.Element({
                html: img.src.indexOf('data:') === 0 ? '' : '<a target="_blank" href="' + img.src + '" title="Open in New Window" class="open-in-new-tab">' + GUI.getNameFromFileSrc(img.src) + '</a>'
            })
        }]
    });

    previewDlg = new GUI.Popup.Dialog({
        alwaysOnTop : true,
        modal       : true,
        title       : name || GUI.getNameFromFileSrc(img.src),
        content     : '',
        toolbuttons : [
            {name: 'close',     img: 'close'}
        ],
        footerButtons: [{
            name: 'toolbar',
            obj: toolbar
        }]
    });

    previewDlg.create();
    previewDlg.dom.style.width = 'auto';

    previeImg = new Image();

    previeImg.onload = function() {
        var width, height, xRatio, yRatio, ratio, useXRatio, maxWidth, maxHeight;

        GUI.Dom.addClass(previeImg, 'preview-popup-image');

        contentDom = GUI.$(previewDlg.contentId);
        contentDom.appendChild(previeImg);

        width = GUI.constrain(previeImg.width, 100, GUI.getWidth() - 20);
        height = GUI.constrain(previeImg.height, 100, GUI.getViewportHeight() - 75);

        if(width < previeImg.width || height < previeImg.height) {
            xRatio = width / previeImg.width;
            yRatio = height / previeImg.height;

            ratio = Math.min(xRatio, yRatio);
            useXRatio = (xRatio === ratio);

            maxWidth   = useXRatio  ? width - 3  : Math.floor(previeImg.width * ratio) - 1;
            maxHeight  = !useXRatio ? height : Math.floor(previeImg.height * ratio);
        } else {
            maxWidth = previeImg.width;
            maxHeight = previeImg.height + 1;
        }

        contentDom.style.overflow = 'auto';
        contentDom.style.width = maxWidth + 'px';
        contentDom.style.height = maxHeight + 'px';

        previewDlg.show();

        previewDlg.glass.dom.on('click', function () {
            previewDlg.close();
        });
    };

    previeImg.src = img.src;
};

GUI.addToPreviewImageListener = function (el) {
    if (el instanceof Array) {
        el.each(function (item) {
            GUI.addToPreviewImageListener(item);
        });

        return;
    }

    var i;

    GUI.previewImages = GUI.previewImages || [];

    el = GUI.$(el);

    if (!el) {
        console.log('Element is not defined');
        return;
    }

    el.on('mouseover', function (e) {
        e = GUI.Event.extend(e);
        var target = e.target;

        if (target.nodeName.toLowerCase() === 'img' && target.src) {

            if (!GUI.previewImages.include(target)) {
                checkImageSize(target, el, 'over');
            }
        }
    });

    el.on('click', function (e) {
        e = GUI.Event.extend(e);
        var target = e.target;

        if (target.nodeName.toLowerCase() === 'img' && target.src) {

            if (GUI.previewImages.include(target)) {
                GUI.showPreview(target);
            } else {
                checkImageSize(target, el, 'click');
            }
        }
    });

    function addToPreviewImages(img) {
        GUI.previewImages.push(img);
        img.style.cursor = 'pointer';
    }

    function checkImageSize(img, holder, nameEvent) {
        var previeImg, widthImg, heightImg;

        previeImg = new Image();
        previeImg.onload = function () {
            widthImg = previeImg.width;
            heightImg = previeImg.height;

            if (
                (widthImg > img.width || heightImg > img.height) &&
                (holder.offsetWidth < widthImg || holder.offsetHeight < heightImg)
            ) {
                addToPreviewImages(img);
                if (nameEvent === 'click') {
                    GUI.showPreview(img);
                }
            }
        };
        previeImg.src = img.src;
    }

};

GUI.resizeBlockToParent = function (baseEl) {
    var els = baseEl.querySelectorAll('iframe');

    if (!els.length) {
        return;
    }

    var resizeFn = function (els) {
        var i, ratio, iframeDataId, newWidth, newHeight, el, holderSize, width, height,
        stopResizeFn = true;

        for (i = 0; i < els.length; i++) {
            iframeDataId = els[i].getAttribute('data-id');

            if (document.querySelector('iframe[data-id="' + iframeDataId + '"]')) {
                stopResizeFn = false;
                break;
            }
        }

        if (stopResizeFn) {
            window.removeEventListener('resize', resizeFn);
            return;
        }

        for (i = 0; i < els.length; i++) {
            el = els[i],
            holderSize = el.parentNode.getBoundingClientRect(),
            width = parseInt(el.getAttribute('data-basewidth'), 10),
            height = parseInt(el.getAttribute('data-baseheight'), 10);

            if (width > holderSize.width && height) {
                ratio = height / width;
                newWidth = holderSize.width;
                newHeight = holderSize.width * ratio;

            } else if (width > holderSize.width && !height) {
                ratio = 0.5625; // ratio 16:9
                newWidth = holderSize.width;
                newHeight = holderSize.width * ratio;

            } else if (!width && !height) {
                continue;

            } else  {
                newWidth = width;
                newHeight = height;
            }

            el.setAttribute('width', newWidth);
            el.setAttribute('height', newHeight);
        }
    }.bind(this, els);

    for (i = 0; i < els.length; i++) {
        els[i].setAttribute('data-id', 'resized-iframe-' + GUI.getUniqId());
        els[i].setAttribute('data-basewidth', els[i].getAttribute('width'));
        els[i].setAttribute('data-baseheight', els[i].getAttribute('height'));
    }

    window.addEventListener('resize', resizeFn);
    resizeFn();
};

GUI.convertSize = function (size) {
    var i = 0;
    function convert() {
        size = (parseInt(size, 10) / 1024).toFixed(1);
        i++;
        size += '';
        if (size.split('.')[0].length > 3) convert();
    }

    size += '';
    if (size.length > 3) convert();
    switch (i) {
        case 0:
            size += ' bytes';
            break;
        case 1:
            size += ' KB';
            break;
        case 2:
            size += ' MB';
            break;
        case 3:
            size += ' GB';
            break;
        default:
            break;
    }
    return size;
};
